import PropTypes from "prop-types"
import { useState } from "react"
import { startsWith, parseInt } from "lodash"
import moment from "moment"
import { Button, Alert, AlertTitle } from "@mui/material"
import Delay from "components/delay"

function isAccountExpirationAlert(message) {
  return startsWith(message, "Your account is scheduled to expire")
}

export default function StaticAlert({ staticAlert, removeStaticAlert, newVersionTime, account }) {
  const overrideWarningKey = `ompnt-${account}-expiration-warning-override`
  const [hideExpirationWarning, setHideExpirationWarning] = useState(false)

  const overrideExpirationWarning = () => {
    window.localStorage.setItem(overrideWarningKey, Date.now())
    setHideExpirationWarning(true)
  }

  const overrideExpired = () => {
    const date = parseInt(window.localStorage.getItem(overrideWarningKey))
    if (!date || moment().diff(moment(date), "days") > 1) {
      return true
    }

    return false
  }

  if (newVersionTime) {
    return <Alert
      severity="warning"
      className="modules_static-alert"
      elevation={2}
      action={<Button color="inherit" onClick={() => { window.location.reload() }}>
        Refresh Now
      </Button>}
    >
      <AlertTitle>Omega Point Update Detected</AlertTitle>
      A newer version is available by refreshing this page. This page will auto-refresh
      &nbsp;
      <Delay time={newVersionTime} />
      &nbsp;
      if no action taken.
    </Alert>
  }

  if (!staticAlert) {
    return null
  }
  const { message, removable } = staticAlert
  let { type } = staticAlert
  if (type === "danger") {
    type = "error"
  }

  // Hack for account expiration alert. We dont want to go back to the server for these
  if (isAccountExpirationAlert(message)) {
    if (!overrideExpired() || hideExpirationWarning) {
      return null
    }

    return <Alert
      severity={type}
      className="modules_static-alert"
      elevation={2}
      onClose={overrideExpirationWarning}
    >
      {message}
    </Alert>
  }

  return <Alert
    severity={type}
    className="modules_static-alert"
    elevation={2}
    onClose={removable ? removeStaticAlert : undefined}
  >
    {message}
  </Alert>
}

StaticAlert.propTypes = {
  staticAlert: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    removable: PropTypes.bool.isRequired,
  }),
  removeStaticAlert: PropTypes.func.isRequired,
  newVersionTime: PropTypes.object,
  account: PropTypes.string.isRequired,
}
